export default {"src":"/_next/static/media/blured-salary.fa34eba1.svg","height":51,"width":143,"blurWidth":0,"blurHeight":0};